import { render, staticRenderFns } from "./UniPost.vue?vue&type=template&id=44032c2a&scoped=true&"
import script from "./UniPost.vue?vue&type=script&lang=js&"
export * from "./UniPost.vue?vue&type=script&lang=js&"
import style0 from "./UniPost.vue?vue&type=style&index=0&id=44032c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44032c2a",
  null
  
)

export default component.exports